// extracted by mini-css-extract-plugin
export default {"search":"Search_search__KSE8e","searchButton":"Search_searchButton__VPZ4S"};